module.exports = __webpack_public_path__ + "static/media/logo.1a7223f7.png";